// @flow

import { type UserInputValues } from '@tectonics/prs/user-input-values';
import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment';

export function customerOutgoingPaymentMapper(userInputValues: UserInputValues): $Shape<OutgoingPayment> {
  return {
    name: userInputValues['customerName'],
    email: userInputValues['customerEmail'],
    accept_terms: userInputValues['acceptTerms'],
  };
}
